<template>
	<div id="demo" class="demobox">
		<div class="common-header-wrap">
            <mt-header class="common-header" title="Live List">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
		<mt-navbar class="tab-nav" v-model="selected">
			<mt-tab-item id="3">Live Preview</mt-tab-item>
            <mt-tab-item id="1">On Live</mt-tab-item>
            <mt-tab-item id="2">Live Playback</mt-tab-item>
        </mt-navbar>
        
        <div v-bind:class="[(selected==1)?'actives':'','tab-containts']">
        	<div class="LiveBroadcastBox">
				<ul>
					<li :items="live_list" :index="index" v-bind:key="index" v-for="(item, index) in live_list" @click="livedetails(item.live_apply_id)">
						<div class="proinforimgbaox">
							<img class="pros" :src="'https://img.duoyp.com/home/live_apply/'+item.live_apply_user_id+'/'+item.live_apply_cover_image" />
							<img class="plays" src="https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220513/401_1652441172795989.png" />
						</div>
						<div class="ExhibitorsLiveTitle">
							<p>{{item.live_apply_name}}</p>
						</div>
						<div class="livebacks"></div>
						<span v-if="item.live_apply_push_state == 1" class="state"><i></i>On Live</span>
						<span v-else-if="item.live_apply_push_state == 2 || item.live_apply_push_state == 0" class="state"><i></i>Pause</span>
					</li>
				</ul>
			</div>
			<div class="Loading" v-if="liveLoadingshow">Loading......</div>
			<div class="Loading" v-if="liveNoLoadingshow">End</div>
        </div>
        <div v-bind:class="[(selected==2)?'actives':'','tab-containts']">
        	<div class="LiveBroadcastBox">
				<ul>
					<li :items="playback_list" :index="index" v-bind:key="index" v-for="(item, index) in playback_list" @click="livedetails(item.live_apply_id)">
						<div class="proinforimgbaox">
							<img class="pros" :src="'https://img.duoyp.com/home/live_apply/'+item.live_apply_user_id+'/'+item.live_apply_cover_image" />
							<img class="plays" src="https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220513/401_1652441172795989.png" />
						</div>
						<div class="ExhibitorsLiveTitle">
							<p>{{item.live_apply_name}}</p>
						</div>
						<div class="livebacks"></div>
						<span class="state"><i></i>Playback</span>
					</li>
				</ul>
			</div>
			<div class="Loading" v-if="playbackLoadingshow">Loading......</div>
			<div class="Loading" v-if="playbackNoLoadingshow">End</div>
        </div>
        
        <div v-bind:class="[(selected==3)?'actives':'','tab-containts']">
        	<div class="LiveBroadcastBox">
				<ul>
					<li :items="live_advancelist" :index="index" v-bind:key="index" v-for="(item, index) in live_advancelist" @click="goLivedetails(item.live_apply_id)">
						<div class="proinforimgbaox">
							<img class="pros" :src="'https://img.duoyp.com/home/live_apply/'+item.live_apply_user_id+'/'+item.live_apply_cover_image" />
							<img class="plays" src="https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220513/401_1652441172795989.png" />
						</div>
						<div class="ExhibitorsLiveTitle">
							<p>{{item.live_apply_name}}</p>
						</div>
						<div class="livebacks"></div>
						<span class="state"><i></i>Reserve</span>
					</li>
				</ul>
			</div>
			<div class="Loading" v-if="advancelistLoadingshow">Loading......</div>
			<div class="Loading" v-if="advancelistNoLoadingshow">End</div>
        </div>
        
	</div>
</template>

<script>
	import LiveFoot from './child/LiveFoot'
	import { getlivelists } from '../../../api/memberLive'
export default {
  name: 'HomeLiveShop',
  data () {
    return {
      shopdetails:'',
      playback_list:"",
      live_list: "",
      playtimelive:'',
      live_advancelist:'',
      selected:"1",
      liveLoadingshow:false,
      liveNoLoadingshow:false,
      playbackLoadingshow:false,
      playbackNoLoadingshow:false,
      advancelistLoadingshow:false,
      advancelistNoLoadingshow:false,
      playbackcurrentpage:1,
      playbacklistpage:1,
      livecurrentpage:1,
      livelistpage:1,
      advancecurrentpage:1,
      advancepage:1
    }
  },
  components: {
    LiveFoot
  },
  mounted () {
  	window.onscroll=false;
  },
  created: function () {
  	
  	var playtime=Date.now();
  	playtime=playtime.toString()
  	this.playtimelive=playtime.substring(0,playtime.length-3);

	getlivelists("",this.currentpage).then((res) => {
		
		this.live_list = res.result.live_list;
		this.playback_list=res.result.playback_list;
		this.live_advancelist=res.result.live_advance;
		window.onscroll=this.pageScroll;
   })
  },
  computed: {
    
  },
  methods: {
	goBack () {
      this.$router.go(-1)
   },
   livedetails:function(liveid){
		this.$router.push({ 'name': 'MemberLiveDetail', 'query': { 'live_apply_id': liveid } })
	},
	goLivedetails(live_apply_id){
    	this.$router.push({ name: 'Homewxsubscribe', query: { id: live_apply_id,"livetypes":"1" } })
    },
	livelistbox(){
		getlivelists(this.selected,"").then((res) => {
			if(this.selected=="1"){
				this.live_list = res.result.live_list;
			}else if(this.selected=="2"){
				this.playback_list=res.result.live_list;
			}else{
				this.live_advancelist=res.result.live_list;
			}
		})
	},
	pageScroll(){
	    // 获取滚动的距离
	    let scrollTop=document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
	    // 获取滚动的高度（获取整个html的高度）
	    let scrollHeight=document.getElementById('demo').scrollHeight;
	    // 获取屏幕(浏览器)高度
	    let clienHeight=document.documentElement.clientHeight;
	    // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
	    if(scrollTop+clienHeight-scrollHeight >=-50){
	    	//我到底了
	    	if(this.selected=="1"){
		    	if(this.livecurrentpage<=this.livelistpage){
		    		window.onscroll=false;
		    		this.livecurrentpage=this.livecurrentpage+1;
		      		this.liveLoadingshow = true;
		    		getlivelists(this.selected,this.livecurrentpage).then((res) => {
						this.live_list = this.live_list.concat(res.result.live_list);
						this.livelistpage=res.result.page_count;
						if(this.livecurrentpage<="1"){
							this.livecurrentpage="2";
						}
						window.onscroll=this.pageScroll;
	    				this.liveLoadingshow = false;
				    })
		    		
		    	}else{
		    		this.liveLoadingshow = false;
		    		this.liveNoLoadingshow=true;
		    		window.onscroll=false;
		    	}
	    	}else if(this.selected=="2"){
	    		if(this.playbackcurrentpage<=this.playbacklistpage){
		    		window.onscroll=false;
		    		this.playbackcurrentpage=this.playbackcurrentpage+1;
		      		this.playbackLoadingshow = true;
		    		getlivelists(this.selected,this.playbackcurrentpage).then((res) => {
		    			
		    			if(res.result.live_list.length!=0){
		    				this.playback_list=this.playback_list.concat(res.result.live_list);
		    			}
						
						this.playbacklistpage=res.result.page_count;
						if(this.playbackcurrentpage<="1"){
							this.playbackcurrentpage="2";
						}
						window.onscroll=this.pageScroll;
	    				this.playbackLoadingshow = false;
				    })
		    	}else{
		    		this.playbackLoadingshow = false;
		    		this.playbackNoLoadingshow=true;
		    		window.onscroll=false;
		    	}
	    	}else{
	    		if(this.advancecurrentpage<=this.advancepage){
		    		window.onscroll=false;
		    		this.advancecurrentpage=this.advancecurrentpage+1;
		      		this.advancelistLoadingshow = true;
		    		getlivelists(this.selected,this.advancecurrentpage).then((res) => {
						this.live_advancelist = this.live_advancelist.concat(res.result.live_list);
						this.advancepage=res.result.page_count;
						if(this.advancecurrentpage<="1"){
							this.advancecurrentpage="2";
						}
						window.onscroll=this.pageScroll;
	    				this.advancelistLoadingshow = false;
				    })
		    	}else{
		    		this.advancelistLoadingshow = false;
		    		this.advancelistNoLoadingshow=true;
		    		window.onscroll=false;
		    	}
	    	}

	      	      
	      //滚动至底部后请求数据
	    }
	}
  }
}	
</script>

<style scoped>
	.demobox{padding-bottom: 2rem;}
	.tab-nav{position: fixed;top: 2rem;width: 100%;left: 0;z-index: 999999;}
	.tab-containts{display: none;}
    .actives{display: block;}
    .Loading{line-height: 1rem;text-align: center;font-size: 0.8rem;margin-top: 2rem;}
    .LiveBroadcastBox{padding-top: 2.3rem;}
	.LiveBroadcastBox ul{overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;padding: 0.3rem 0.2rem;}
	.LiveBroadcastBox ul li{width: 48%;float: left;box-sizing: border-box;display: inline-block;position: relative;padding: 0.5rem 0.3rem;border-top: 1px solid #f5f5f5;margin: 0.2rem 1%;border-radius: 8px;overflow: hidden;}
	.livebacks{position: absolute;z-index: 1;background: rgba(0,0,0,0.2);width: 100%;height: 100%;left: 0;top: 0;}
	.LiveBroadcastBox ul li:nth-child(odd){border-right: 1px solid #f5f5f5;}
	.LiveBroadcastBox ul li .proinforimgbaox{width: 100%;text-align: center;min-height: 5rem;}
	.LiveBroadcastBox ul li .proinforimgbaox img.pros{width: 100%;}
	.LiveBroadcastBox ul li img.plays{width: 30px;display: inline-block;position: absolute;left: 50%;top: 50%;margin-left: -15px;margin-top: -15px;z-index: 10;}
	.ExhibitorsLiveTitle{position: absolute;width: 100%;left: 0px;bottom: 0px;background: rgba(0,0,0,0.7);padding: 0 5px;z-index: 20;box-sizing: border-box;}
	.ExhibitorsLiveTitle p{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 0.55rem;color: #fff;line-height: 1.2rem;}
	.LiveBroadcastBox ul li span.state{display: inline-block;padding: 0 8px;line-height: 20px;background: rgba(0,0,0,0.7);font-size: 12px;color: #fff;
	position: absolute;left: 10px;top: 10px;z-index: 30;border-radius: 20px;}
	.LiveBroadcastBox ul li span.state i{display: inline-block;margin-right: 3px;width: 9px;height: 9px;background: #E60012;border-radius: 50%;vertical-align: inherit;}
</style>